module.exports = __webpack_public_path__ + "static/media/release.notes.9e4b6fcb.md";